























import { Vue, Component, Prop } from 'vue-property-decorator';
import env from '@/env';
import axios from 'axios';
import { Step } from '@/types';
import StepCard from '@/components/Steps/StepCard.vue';

@Component({
  components: { StepCard }
})
export default class StepIdTooltip extends Vue {
  @Prop()
  id!: number;

  @Prop()
  blueprint?: boolean;

  @Prop()
  eye?: boolean;

  @Prop()
  eyeSlash?: boolean;

  step: Step | boolean = false;

  private fetching = false;

  async fetchData() {
    if (this.fetching) return;
    this.fetching = true;
    const { data: step }: { data: Step } = await axios.get(`${env.backend_url}/step/${this.id}`);
    this.step = step;
  }
}
